module.exports = __webpack_public_path__ + "static/media/report4.6fb971ef.xlsx";